import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { logoutUser } from 'actions/index';

function Logout() {
    const dispatch = useDispatch();
    const history = useHistory();

    useEffect(() => {
        dispatch(logoutUser({
            callback: () => {
                localStorage.removeItem('jwt_token');
                history.push('/login');
            }
        }));
    }, []);

    return null;
}

export default Logout;
